import ALL_APP_USERS from "./query.gql";

export interface AppUserData {
  id: string;
  name: string;
  start: number;
  end: number;
  createdAt: number;
  expired: boolean;
  prePeriod: boolean;
}

export interface AllAppUserData {
  appUserFeed: {
    appUsers: AppUserData[];
  };
}

export { ALL_APP_USERS };
